import moment from 'moment';
const TIME_FORMAT = 'HH:mm';

const getPrebookingHash = (prebooking) => {
  if (!prebooking) {
    return '';
  }

  const { route, vehicle_type, amount, distance } = prebooking;

  const firstSlot = getFirstSlot(prebooking);
  const { start_time, end_time } = firstSlot;
  const startDate = moment(start_time);
  const endDate = moment(end_time);
  const datetimes = `${startDate.format(TIME_FORMAT)}-${endDate.format(TIME_FORMAT)}`;

  const amountFormatted = Math.round(amount * 100) / 100;

  return `${route.origin}-${route.destination}//${vehicle_type}//${amountFormatted}//${distance}//${datetimes}`;
};

const prepareForCreation = (forecast, acceptanceMax) => {
  const {
    route: { origin, destination } = {},
    region,
    vehicle_type,
    amount,
    distance,
    start_date,
    end_date,
    start_time,
    end_time,
  } = forecast || {};

  const startDate = moment(start_date).format('YYYY-MM-DD');
  const endDate = moment(end_date).format('YYYY-MM-DD');

  const startTime = moment(start_time).utc().format('HH:mm');
  const endTime = moment(end_time).utc().format('HH:mm');

  return {
    route: { origin, destination },
    region,
    vehicle_type,
    amount,
    distance,
    start_date: startDate,
    end_date: endDate,
    slots: [{ start_time: startTime, end_time: endTime, acceptance_max: acceptanceMax }],
  };
};

const getPrebookingStatus = (prebookingsMap, forecast) => {
  const forecastHash = getPrebookingHash(forecast);

  if (prebookingsMap[forecastHash]) {
    return prebookingsMap[forecastHash];
  }

  return null;
};

const mapForecast = (prebookingsMap) => (forecast) => {
  const prebookingStatus = getPrebookingStatus(prebookingsMap, forecast);

  return {
    ...forecast,
    prebookingStatus,
  };
};

const getFirstSlot = (prebooking) => {
  if (!prebooking) {
    return {};
  }
  const { slots = [] } = prebooking;

  if (slots.length) {
    return slots[0] || {};
  }

  const { start_time, end_time } = prebooking;

  return {
    start_time,
    end_time,
  };
};

const createPrebookingsMap = (acc, prebooking) => {
  const hash = getPrebookingHash(prebooking);
  const firstSlot = getFirstSlot(prebooking);
  const { acceptance_max, acceptance_count } = firstSlot;

  const { launched: prevLaunched = 0, accepted: prevAccepted = 0 } = acc[hash] || {};

  return {
    ...acc,
    [hash]: {
      launched: prevLaunched + acceptance_max,
      accepted: prevAccepted + acceptance_count,
    },
  };
};

const groupPrebookingsByDate = (acc, prebooking) => {
  const { start_time, end_time } = prebooking;
  const startDate = moment(start_time);
  const endDate = moment(end_time);
  const date = `${startDate.format(TIME_FORMAT)}-${endDate.format(TIME_FORMAT)}`;
  const currentDate = acc[date] || [];

  return {
    ...acc,
    [date]: [...currentDate, prebooking],
  };
};

export {
  getPrebookingHash,
  mapForecast,
  createPrebookingsMap,
  prepareForCreation,
  groupPrebookingsByDate,
};
